const orgCategoryData = [
  { category_name: "IT", category_value: "IT" },
  { category_name: "Cloth", category_value: "Cloth" },
  { category_name: "School", category_value: "School" },
  { category_name: "Handicraft", category_value: "Handicraft" },
  // Add more pages as needed
];

export default orgCategoryData;
